import classNames from 'classnames';
import { StreamingText } from 'src/components/StreamingText';
import { Citation, MessageSkill } from 'src/types';
import { ThinkingSection } from 'src/v2/components/ThinkingSection';
import { CotReasoning } from 'src/types/models/CotReasoning';

interface ThreadMessageContentProps {
  content: string;
  className?: string;
  isStreaming?: boolean;
  references?: Citation[];
  reasoning?: CotReasoning;
  isDeepResearch?: boolean;
  messageSkill: MessageSkill | null;
}

export const ThreadMessageContent = ({
  content,
  className,
  isStreaming,
  references,
  reasoning,
  isDeepResearch,
  messageSkill,
}: ThreadMessageContentProps) => {
  if (!content && !reasoning) {
    return null;
  }

  return (
    <div className={classNames('nj-thread-message--content', className)}>
      {!!reasoning && (
        <ThinkingSection
          reasoning={reasoning}
          defaultExpanded={!content}
          isDone={!!content}
          isDeepResearch={isDeepResearch}
        />
      )}
      {content && (
        <StreamingText
          isStreaming={isStreaming}
          content={content}
          references={references}
          messageSkill={messageSkill}
        />
      )}
    </div>
  );
};
